import React, { useEffect, useState, useRef } from "react";
import { Box, Flex, Button } from "ui-components";
import FormattedMessage from "components/FormattedMessage";
import { safeEval } from "utils/helpers";
import get from "lodash/get";
import Spinner, { styles } from "components/Spinner";
import { setData } from "ducks/actions/index";
import { useDispatch } from "react-redux";

const TimedMessageButton = ({ data = {}, messageData, ...props }) => {
  const { delayed, btnLabel, msg, msgBtn, style } = data;
  const btnState = delayed ? false : true;
  const [showMainBtn, setShowMainButton] = useState(btnState);
  const [isMsgBtnLinkLoading, setIsMsgBtnLinkLoading] = useState(true);
  const [showMsg, setShowMsg] = useState(
    get(props, "ekycValidation.showMsgEkycValidationFailure", false)
  );
  const msgBtnEnabled = get(msgBtn, "enabled", false);
  const msgBtnLink = get(msgBtn, "link", null);
  const msgBtnLabel = get(msgBtn, "label", "");
  let msgBtnLinkRef = useRef(
    safeEval(get, get(props, "formValues"), msgBtnLink, null, props)
  );
  const dispatch = useDispatch();

  useEffect(() => {
    if (msgBtnLinkRef)
      msgBtnLinkRef.current = safeEval(
        get,
        get(props, "formValues"),
        msgBtnLink,
        null,
        props
      );
    if (msgBtnLinkRef.current) {
      setIsMsgBtnLinkLoading(false);
    } else {
      setIsMsgBtnLinkLoading(true);
    }
  }, [props, msgBtnLink]);

  const onClickMainBtn = () => {
    setShowMsg(true);
    dispatch(setData({ key: "MyInfoTroubleEvent" }));
  };
  const onClickMessageBtn = () => {
    return (window.location = msgBtnLinkRef.current);
  };

  !showMainBtn &&
    setTimeout(() => {
      setShowMainButton(true);
      console.log(delayed);
    }, delayed);

  return (
    <>
      {showMainBtn && (
        <Flex
          justifyContent={"center"}
          alignItems={"center"}
          flexDirection={"column"}
          style={{ ...style }}
        >
          <Box sx={{ textAlign: "center" }}>
            <Button
              as="a"
              onClick={onClickMainBtn}
              sx={{
                background: "none",
                backgroundColor: "transparent!important",
                border: "none",
                padding: 0,
                color: "cta.color",
                textDecoration: "underline",
                cursor: "pointer"
              }}
            >
              <FormattedMessage html id={btnLabel} values={messageData} />
            </Button>
          </Box>
          {showMsg && (
            <>
              <Box pt={3} pb={3}>
                <FormattedMessage html id={msg} values={messageData} />
              </Box>
              {msgBtnEnabled && (
                <Box>
                  <Button
                    variant="outline"
                    onClick={onClickMessageBtn}
                    disabled={isMsgBtnLinkLoading}
                  >
                    {isMsgBtnLinkLoading ? (
                      <Spinner size={10} sx={styles.inlineMessage} />
                    ) : (
                      <FormattedMessage
                        html
                        id={msgBtnLabel}
                        values={messageData}
                      />
                    )}
                  </Button>
                </Box>
              )}
            </>
          )}
        </Flex>
      )}
    </>
  );
};

export default TimedMessageButton;
